import { Controller } from '@hotwired/stimulus'
import FetchCall from '../shared/local_fetch_call'

export default class extends Controller {
  static targets = ['guestNameInput', 'adultsSelect', 'saveButton', 'message']
  static values = {
    roomId: String,
    opportunityId: String,
    completedGuestName: String,
    completedAdults: Number
  }

  connect() {
    this.processing = false
    // Set initial values if present
    if (this.hasGuestNameInputTarget && this.completedGuestNameValue) {
      this.guestNameInputTarget.value = this.completedGuestNameValue
    }
    if (this.hasAdultsSelectTarget && this.completedAdultsValue > 0) {
      this.adultsSelectTarget.value = this.completedAdultsValue
    } else if (this.hasAdultsSelectTarget) {
      this.adultsSelectTarget.value = 2 // Default to 2
    }
  }

  resetMessage() {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = ''
      this.messageTarget.classList.add('hidden')
    }
  }

  updateRoom(event) {
    event.preventDefault()

    if (this.processing) {
      return
    }

    this.processing = true

    const guestName = this.hasGuestNameInputTarget ? this.guestNameInputTarget.value : this.completedGuestNameValue
    const numberOfAdults = this.hasAdultsSelectTarget ? this.adultsSelectTarget.value : this.completedAdultsValue

    const body = JSON.stringify({
      rooming_list: {
        guest_name: guestName,
        quantity: numberOfAdults
      }
    })

    FetchCall.fetchWithLocale(
      `/oa/opportunities/${this.opportunityIdValue}/rooming_lists/${this.roomIdValue}`,
      'PUT',
      body
    ).then(response => {
      if (!response.errors || Object.keys(response.errors).length === 0) {
        // Success - reload the page to show updated state
        window.location.reload()
      } else {
        // Show error message
        this.showMessage(this.element.dataset.updateFailedMessage || 'We could not update your hotel information. Please contact us if the problem continues.')
      }
      this.processing = false
    }).catch(() => {
      this.showMessage(this.element.dataset.updateFailedMessage || 'We could not update your hotel information. Please contact us if the problem continues.')
      this.processing = false
    })
  }

  showMessage(text) {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = text
      this.messageTarget.classList.remove('hidden')
    }
  }
}
